module.exports = __webpack_public_path__ + "static/media/boring-weather.b6007959.jpg";